// stores/pageActions.ts
import { defineStore } from "pinia"
export const usePageActions = defineStore("pageActions", {
    state: () => ({ items: [] as any[] }),
    actions: { set(items:any[]){ this.items = items }, clear(){ this.items = [] } },
})
